import { useParams } from "react-router-dom";

import { db } from "astrid-firebase";
import { useDocumentData } from "astrid-firestore/src/hooks";

import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import ExportPresetForm from "./ExportPresetForm";

export default function ExportPreset() {
	const { exportPresetId } = useParams();

	const [exportPreset, loading, error] = useDocumentData(db.collection("exportPresets").doc(exportPresetId));

	return (
		<LoadingContext data={exportPreset} loading={loading} error={error}>
			<ExportPresetForm exportPreset={exportPreset} />
		</LoadingContext>
	);
}
